module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"empty":"Nenhum resultado encontrado","views":"Páginas","sheets":"Tabelas","workflows":"Automações"},"en":{"empty":"No matching results","views":"Pages","sheets":"Sheets","workflows":"Workflows"}}')
  delete Component.options._Ctor
}
